// memberHeroRingColor.js

import { createDynamicCSS } from '../../utils/CreateDynamicCSS';

export const MEMBER_HERO_RING_DEFAULT_COLOR = '#004872';

const HEX_RE = /^#[0-9A-Fa-f]{6}$/;

export function sanitizeMemberHeroRingHex(value) {
  const hex = String(value || '').trim();
  return HEX_RE.test(hex) ? hex.toLowerCase() : null;
}

export function resolveMemberHeroRingHex(storedHex, canUseCustomColor = true) {
  if (canUseCustomColor) {
    const custom = sanitizeMemberHeroRingHex(storedHex);
    if (custom) return custom;
  }
  return MEMBER_HERO_RING_DEFAULT_COLOR;
}

function hexClassSuffix(hex) {
  return hex.replace('#', '').toLowerCase();
}

export function getMemberHeroRingBorderClass(hex) {
  const color = sanitizeMemberHeroRingHex(hex) || MEMBER_HERO_RING_DEFAULT_COLOR;
  const className = `member-hero-ring-border-${hexClassSuffix(color)}`;
  createDynamicCSS(className, { borderColor: color });
  return className;
}

export function getMemberHeroRingHaloClass(hex) {
  const color = sanitizeMemberHeroRingHex(hex) || MEMBER_HERO_RING_DEFAULT_COLOR;
  const className = `member-hero-ring-halo-${hexClassSuffix(color)}`;
  createDynamicCSS(className, {
    boxShadow: `0 0 10px 4px ${color}`,
    opacity: '0.5',
  });
  return className;
}

/** Public roster/profile view: custom ring for all; halo only when permitted. */
export function resolveMemberHeroRingDisplay(storedHex, { showHalo = false } = {}) {
  const customColor = sanitizeMemberHeroRingHex(storedHex);
  const ringColor = customColor || MEMBER_HERO_RING_DEFAULT_COLOR;
  return {
    ringColor,
    showHalo: Boolean(showHalo),
    ringBorderClass: getMemberHeroRingBorderClass(ringColor),
    haloClass: showHalo ? getMemberHeroRingHaloClass(ringColor) : '',
  };
}
